<div class="cart">
  <div class="cart-title">
    PEDIDO
  </div>
  <table class="table table-hover table-striped">
    @if (cart.n_items > 0) {
      <thead>
        <tr>
          <th>Qtd</th>
          <th>Item</th>
          <th>Valor total</th>
          <th> &nbsp; &nbsp; </th>
        </tr>
      </thead>
    }
    <tbody>
      @for (po of cart.cart_items; track po) {
        <tr>
          <td>{{po.quantity}}</td>
          <td>
            {{po.product.name}}
            @if (po.notes_attributes) {
              <ul>
                @for (note of po.notes_attributes; track note) {
                  <li>
                    {{note.text}}
                  </li>
                }
              </ul>
            }
            @if (po.poptional_selections.length > 0) {
              <div class="poptionals">
                <i>OPÇÕES:</i>
                <ul>
                  @for (sel of po.poptional_selections; track sel) {
                    <span>
                      @for (lbl of sel.descriptions(); track lbl) {
                        <li>
                          @if (lbl.qty > 1) {
                            <b>{{lbl.qty}} </b>
                            }{{lbl.text}}
                            @if (lbl.price > 0) {
                              <span>+{{lbl.price | currency:'BRL'}}</span>
                            }
                          </li>
                        }
                      </span>
                    }
                  </ul>
                </div>
              }
            </td>
            <td>{{po.prettyPrice}}</td>
            <td class="actions">
              <button class="btn btn-sm btn-danger" (click)="removeItem(po)">
                <fa-icon [icon]="faXmark"></fa-icon>
              </button>
            </td>
          </tr>
        }
        @if (cart.n_items == 0) {
          <tr>
            <td></td>
            <td>Seu carrinho está vazio</td>
            <td></td>
            <td>
              <button (click)="exit('carrinho vazio')" class="btn btn-sm btn-secondary">
                Voltar
              </button>
            </td>
          </tr>
        }
        @if (cart.n_items > 0) {
          <tr>
            <td></td>
            <td class="total">TOTAL:</td>
            <td>{{cart.prettyTotal}}</td>
            <td class="actions">
              <button class="btn btn-sm btn-success" [disabled]="sending" (click)="send()">{{ sending ? 'ENVIANDO...' : 'ENVIAR' }}</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>